/**
 * Format an amount in the given currency, using Spanish number convention (es-ES) for all markets.
 * Operators are predominantly ES-based; locale-specific number conventions are not load-bearing
 * for any customer-facing path (Customer.io owns customer-visible formatting).
 */
export const formatCurrency = (amount: number, currency: string = 'EUR'): string =>
    Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency,
    }).format(amount);

/**
 * Return the currency symbol for a given currency, formatted under es-ES convention.
 * Useful for input field suffixes where the formatted value is rendered separately.
 */
export const currencySymbolFor = (currency: string = 'EUR'): string => {
    const parts = Intl.NumberFormat('es-ES', { style: 'currency', currency }).formatToParts(0);
    return parts.find((p) => p.type === 'currency')?.value ?? currency;
};
